var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 131,
    viewBox: "0 0 335 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5340_28342",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 131
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 131,
    rx: 12,
    fill: "#E3E0FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 130,
    rx: 11.5,
    stroke: "#ffbb00",
    strokeOpacity: 0.11
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5340_28342)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5340_28342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.561 81.7713C222.859 74.2544 206.936 57.6881 201.12 35.749C195.304 13.81 200.93 -8.46865 214.321 -24.7581C234.022 -17.2412 249.946 -0.674899 255.762 21.2642C261.577 43.2032 255.952 65.4819 242.561 81.7713Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.561 81.7713C222.859 74.2544 206.936 57.6881 201.12 35.749C195.304 13.81 200.93 -8.46865 214.321 -24.7581C234.022 -17.2412 249.946 -0.674899 255.762 21.2642C261.577 43.2032 255.952 65.4819 242.561 81.7713Z",
    fill: "#E3E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.561 81.7713L239.337 90.2219C242.969 91.6076 247.08 90.5178 249.548 87.515L242.561 81.7713ZM214.321 -24.7581L217.545 -33.2087C213.913 -34.5944 209.802 -33.5046 207.333 -30.5018L214.321 -24.7581ZM245.785 73.3207C228.686 66.7966 214.902 52.4385 209.863 33.4313L192.377 38.0667C198.97 62.9377 217.033 81.7122 239.337 90.2219L245.785 73.3207ZM209.863 33.4313C204.824 14.4243 209.686 -4.87648 221.308 -19.0144L207.333 -30.5018C192.174 -12.0608 185.784 13.1958 192.377 38.0667L209.863 33.4313ZM211.096 -16.3075C228.196 -9.7834 241.98 4.57469 247.019 23.5819L264.504 18.9466C257.911 -5.92449 239.849 -24.699 217.545 -33.2087L211.096 -16.3075ZM247.019 23.5819C252.057 42.5889 247.196 61.8897 235.574 76.0276L249.548 87.515C264.707 69.074 271.097 43.8174 264.504 18.9466L247.019 23.5819Z",
    fill: "#ffbb00",
    mask: "url(#path-3-inside-1_5340_28342)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_5340_28342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.8 81.2488C232.313 62.415 231.718 39.4428 242.211 19.3158C252.705 -0.810228 271.879 -13.4742 292.751 -16.4793C302.238 2.35449 302.833 25.3267 292.339 45.4537C281.846 65.5797 262.672 78.2436 241.8 81.2488Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.8 81.2488C232.313 62.415 231.718 39.4428 242.211 19.3158C252.705 -0.810228 271.879 -13.4742 292.751 -16.4793C302.238 2.35449 302.833 25.3267 292.339 45.4537C281.846 65.5797 262.672 78.2436 241.8 81.2488Z",
    fill: "#E3E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.8 81.2488L233.722 85.318C235.471 88.7893 239.242 90.7553 243.089 90.2014L241.8 81.2488ZM292.751 -16.4793L300.829 -20.5485C299.08 -24.0198 295.309 -25.9858 291.462 -25.4319L292.751 -16.4793ZM249.878 77.1797C241.644 60.8335 241.14 40.9346 250.232 23.4973L234.191 15.1342C222.295 37.951 222.982 63.9966 233.722 85.318L249.878 77.1797ZM250.232 23.4973C259.323 6.06096 275.924 -4.91857 294.04 -7.52684L291.462 -25.4319C267.833 -22.0297 246.087 -7.68142 234.191 15.1342L250.232 23.4973ZM284.673 -12.4102C292.907 3.93603 293.411 23.8349 284.319 41.2722L300.36 49.6353C312.256 26.8185 311.569 0.772938 300.829 -20.5485L284.673 -12.4102ZM284.319 41.2722C275.228 58.7085 258.626 69.6881 240.511 72.2963L243.089 90.2014C266.718 86.7992 288.464 72.4509 300.36 49.6353L284.319 41.2722Z",
    fill: "#ffbb00",
    mask: "url(#path-5-inside-2_5340_28342)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_5340_28342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.523 81.5828C249.837 61.8023 266.24 45.7074 288.12 39.6662C310 33.6253 332.337 39.0235 348.764 52.2486C341.45 72.029 325.047 88.124 303.166 94.1651C281.287 100.206 258.95 94.8079 242.523 81.5828Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.523 81.5828C249.837 61.8023 266.24 45.7074 288.12 39.6662C310 33.6253 332.337 39.0235 348.764 52.2486C341.45 72.029 325.047 88.124 303.166 94.1651C281.287 100.206 258.95 94.8079 242.523 81.5828Z",
    fill: "#E3E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.523 81.5828L234.04 78.4461C232.692 82.0916 233.824 86.1905 236.851 88.6279L242.523 81.5828ZM348.764 52.2486L357.247 55.3852C358.595 51.7398 357.463 47.6408 354.436 45.2034L348.764 52.2486ZM251.007 84.7194C257.354 67.5515 271.571 53.6187 290.528 48.3849L285.713 30.9476C260.909 37.7961 242.319 56.0531 234.04 78.4461L251.007 84.7194ZM290.528 48.3849C309.483 43.1512 328.835 47.8154 343.091 59.2938L354.436 45.2034C335.84 30.2315 310.517 24.0993 285.713 30.9476L290.528 48.3849ZM340.28 49.112C333.933 66.2798 319.716 80.2127 300.759 85.4465L305.574 102.884C330.378 96.0353 348.968 77.7782 357.247 55.3852L340.28 49.112ZM300.759 85.4465C281.803 90.6802 262.452 86.0159 248.196 74.5376L236.851 88.6279C255.447 103.6 280.77 109.732 305.574 102.884L300.759 85.4465Z",
    fill: "#ffbb00",
    mask: "url(#path-7-inside-3_5340_28342)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-4_5340_28342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.277 142.734C172.256 149.792 158.113 151.625 145.019 146.431C131.925 141.238 122.883 130.21 119.695 117.517C130.716 110.459 144.859 108.626 157.954 113.82C171.048 119.013 180.089 130.041 183.277 142.734Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.277 142.734C172.256 149.792 158.113 151.625 145.019 146.431C131.925 141.238 122.883 130.21 119.695 117.517C130.716 110.459 144.859 108.626 157.954 113.82C171.048 119.013 180.089 130.041 183.277 142.734Z",
    fill: "#E3E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.277 142.734L186.304 147.461C188.336 146.16 189.309 143.707 188.721 141.367L183.277 142.734ZM119.695 117.517L116.668 112.789C114.636 114.09 113.663 116.544 114.251 118.884L119.695 117.517ZM180.25 138.007C170.684 144.132 158.433 145.712 147.088 141.213L142.949 151.649C157.793 157.537 173.827 155.451 186.304 147.461L180.25 138.007ZM147.088 141.213C135.744 136.714 127.906 127.166 125.14 116.149L114.251 118.884C117.859 133.254 128.105 145.762 142.949 151.649L147.088 141.213ZM122.722 122.244C132.288 116.119 144.54 114.538 155.884 119.038L160.023 108.601C145.179 102.714 129.145 104.799 116.668 112.789L122.722 122.244ZM155.884 119.038C167.228 123.537 175.066 133.085 177.832 144.101L188.721 141.367C185.113 126.997 174.867 114.489 160.023 108.601L155.884 119.038Z",
    fill: "#ffbb00",
    mask: "url(#path-9-inside-4_5340_28342)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-5_5340_28342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.769 81.4321C165.669 83.6475 177.352 91.8276 183.524 104.492C189.695 117.155 188.939 131.396 182.737 142.921C169.837 140.705 158.154 132.525 151.982 119.861C145.811 107.198 146.567 92.9568 152.769 81.4321Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.769 81.4321C165.669 83.6475 177.352 91.8276 183.524 104.492C189.695 117.155 188.939 131.396 182.737 142.921C169.837 140.705 158.154 132.525 151.982 119.861C145.811 107.198 146.567 92.9568 152.769 81.4321Z",
    fill: "#E3E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.769 81.4321L153.719 75.8995C151.342 75.4912 148.969 76.6475 147.826 78.7718L152.769 81.4321ZM182.737 142.921L181.787 148.453C184.165 148.862 186.537 147.705 187.68 145.581L182.737 142.921ZM151.819 86.9648C163.015 88.8876 173.131 95.9792 178.478 106.951L188.57 102.032C181.574 87.676 168.323 78.4075 153.719 75.8995L151.819 86.9648ZM178.478 106.951C183.824 117.922 183.177 130.258 177.794 140.26L187.68 145.581C194.702 132.534 195.566 116.388 188.57 102.032L178.478 106.951ZM183.687 137.388C172.491 135.465 162.375 128.374 157.028 117.402L146.936 122.32C153.932 136.677 167.183 145.945 181.787 148.453L183.687 137.388ZM157.028 117.402C151.682 106.431 152.329 94.0949 157.712 84.0924L147.826 78.7718C140.804 91.8187 139.94 107.965 146.936 122.32L157.028 117.402Z",
    fill: "#ffbb00",
    mask: "url(#path-11-inside-5_5340_28342)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-6_5340_28342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.169 142.688C175.997 131.739 174.018 117.614 179.077 104.465C184.137 91.3173 195.073 82.1626 207.734 78.8457C214.907 89.7946 216.886 103.92 211.826 117.068C206.767 130.216 195.83 139.371 183.169 142.688Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.169 142.688C175.997 131.739 174.018 117.614 179.077 104.465C184.137 91.3173 195.073 82.1626 207.734 78.8457C214.907 89.7946 216.886 103.92 211.826 117.068C206.767 130.216 195.83 139.371 183.169 142.688Z",
    fill: "#E3E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.169 142.688L178.473 145.764C179.795 147.782 182.258 148.729 184.592 148.118L183.169 142.688ZM207.734 78.8457L212.43 75.7695C211.108 73.7517 208.645 72.804 206.312 73.4153L207.734 78.8457ZM187.865 139.611C181.64 130.109 179.933 117.872 184.316 106.481L173.838 102.449C168.102 117.355 170.354 133.369 178.473 145.764L187.865 139.611ZM184.316 106.481C188.7 95.0904 198.168 87.1549 209.157 84.276L206.312 73.4153C191.978 77.1703 179.574 87.5442 173.838 102.449L184.316 106.481ZM203.038 81.9218C209.264 91.4246 210.97 103.661 206.587 115.052L217.065 119.084C222.801 104.179 220.55 88.1645 212.43 75.7695L203.038 81.9218ZM206.587 115.052C202.204 126.443 192.735 134.378 181.747 137.257L184.592 148.118C198.925 144.363 211.33 133.989 217.065 119.084L206.587 115.052Z",
    fill: "#ffbb00",
    mask: "url(#path-13-inside-6_5340_28342)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalCardBg);
export default __webpack_public_path__ + "static/media/HospitalCardBg.52cdfb8b72183bf6f11dbe7c2c51c554.svg";
export { ForwardRef as ReactComponent };